import _pt from "prop-types";
var _excluded = ["children", "exit", "showModal"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useEffect, useLayoutEffect } from 'react';
import dialogPolyfill from './polyfill';

var NativeDialog = function NativeDialog(_ref) {
  var children = _ref.children,
      exit = _ref.exit,
      showModal = _ref.showModal,
      dialogProps = _objectWithoutProperties(_ref, _excluded);

  var dialogRef = useRef(null); // Register dialog with the polyfill if necessary

  useLayoutEffect(function () {
    // The registerDialog function itself determines if the polyfill needs to be applied
    dialogPolyfill.registerDialog(dialogRef.current);
  }); // Open and close the dialog with the appropriate method on mount and unmount

  useEffect(function () {
    var dialogNode = dialogRef.current;
    showModal ? dialogNode.showModal() : dialogNode.show();
    return function () {
      dialogNode.close();
    };
  }, [showModal]); // Bind and unbind cancel event listeners on mount and unmount

  useEffect(function () {
    var dialogNode = dialogRef.current;

    var handleCancel = function handleCancel(event) {
      event.preventDefault();
      exit();
    };

    dialogNode.addEventListener('cancel', handleCancel);
    return function () {
      dialogNode.removeEventListener('cancel', handleCancel);
    };
  }, [exit]);
  return /*#__PURE__*/React.createElement("dialog", _extends({
    ref: dialogRef
  }, dialogProps), children);
};

NativeDialog.propTypes = {
  children: _pt.node.isRequired,

  /**
     * Function called to close dialog.
     */
  exit: _pt.func.isRequired,

  /**
     * Determines which native dialog method is called to open the dialog. If the dialog
     * is opened with `showModal`, focus will be trapped inside the dialog, and it will
     * need to be closed before the rest of the page can be interacted with. See the
     * [`showModal` MDN documentation](https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/showModal)
     * for more details.
     */
  showModal: _pt.bool
};
export default NativeDialog;